/* eslint-disable max-len */


interface ClientConfig {
  firebaseConfig: Record<string, string>,
  functionsConfig: string[]
}

const clients: Record<string, ClientConfig> = {
  'telemed-drtis': {
    firebaseConfig: {
      apiKey: 'AIzaSyC9wJSfwNZtsZTpO3nCRWMI4usrctPqB1A',
      authDomain: 'telemed-drtis.firebaseapp.com',
      databaseURL: 'https://telemed-drtis.firebaseio.com',
      projectId: 'telemed-drtis',
      storageBucket: 'telemed-drtis.appspot.com',
      messagingSenderId: '235972025281',
      appId: '1:235972025281:web:0a04701a21217e1fa0ed40',
      measurementId: 'G-TEEL23PF8M',
    },
    functionsConfig: [
      'app.public_url="https://webconsulta.drtis.com.br"',
      'smtp.clientname="Dr. TIS Demonstração"',
    ],
  },
  'telemed-ccg': {
    firebaseConfig: {
      apiKey: 'AIzaSyCiHc-bKreB2ncJMR65ddvYH9DlSF3-h7I',
      authDomain: 'telemed-ccg.firebaseapp.com',
      databaseURL: 'https://telemed-ccg.firebaseio.com',
      projectId: 'telemed-ccg',
      storageBucket: 'telemed-ccg.appspot.com',
      messagingSenderId: '136377162541',
      appId: '1:136377162541:web:eb3379cb8230fd070551a4',
      measurementId: 'G-FE9Y0QYETD',
    },
    functionsConfig: [
      'app.public_url="https://ccg.drtis.com.br"',
      'smtp.clientname="CCG"',
    ],
  },
  'telemed-hosp-samaritano': {
    firebaseConfig: {
      apiKey: 'AIzaSyBnqL7pmo3176-LPQnpksKgedMuSQMre74',
      authDomain: 'telemed-hosp-samaritano.firebaseapp.com',
      databaseURL: 'https://telemed-hosp-samaritano.firebaseio.com',
      projectId: 'telemed-hosp-samaritano',
      storageBucket: 'telemed-hosp-samaritano.appspot.com',
      messagingSenderId: '666402826181',
      appId: '1:666402826181:web:a8584e70434a918de10dac',
      measurementId: 'G-RP5LTYNNPK',
    },
    functionsConfig: [
      'app.public_url="https://phs.telemedicina.drtis.com.br"',
      'smtp.clientname="Hospital Samaritano"',
    ],
  },
  'telemed-moinhos': {
    firebaseConfig: {
      apiKey: 'AIzaSyAdzJ36jWVv4Pvyui6iLAcWO63CfzlOHMk',
      authDomain: 'telemed-moinhos.firebaseapp.com',
      databaseURL: 'https://telemed-moinhos.firebaseio.com',
      projectId: 'telemed-moinhos',
      storageBucket: 'telemed-moinhos.appspot.com',
      messagingSenderId: '479235577578',
      appId: '1:479235577578:web:19ed7e4b9ebb50deabe993',
      measurementId: 'G-HPGWY833RN',
    },
    functionsConfig: [
      'app.public_url="https://telemedicina2.hospitalmoinhos.org.br"',
      'smtp.clientname="Hospital Moinhos de Vento"',
    ],
  },
  'telemed-santacasa': {
    firebaseConfig: {
      apiKey: 'AIzaSyCq9NsyCIE189k4tpvMwF_PMJEbHatnFFA',
      authDomain: 'telemed-santacasa.firebaseapp.com',
      databaseURL: 'https://telemed-santacasa.firebaseio.com',
      projectId: 'telemed-santacasa',
      storageBucket: 'telemed-santacasa.appspot.com',
      messagingSenderId: '438756846053',
      appId: '1:438756846053:web:43e37e1d608af5f84e270c',
      measurementId: 'G-8ZMNJ4WBBM',
    },
    functionsConfig: [
      'app.public_url="https://telemedicina.santacasa.org.br"',
      'smtp.clientname="Conexão Santa Casa"',
    ],
  },
  'telemed-medtrabstacasa': {
    firebaseConfig: {
      apiKey: 'AIzaSyCGR6ZAN8ASCXqhJbC4bcuWX75WIHDNsr8',
      authDomain: 'telemed-medtrabstacasa.firebaseapp.com',
      databaseURL: 'https://telemed-medtrabstacasa.firebaseio.com',
      projectId: 'telemed-medtrabstacasa',
      storageBucket: 'telemed-medtrabstacasa.appspot.com',
      messagingSenderId: '1056346380329',
      appId: '1:1056346380329:web:2a97a897f5338d67b42438',
      measurementId: 'G-TFSL7M9ZYZ',
    },
    functionsConfig: [
      'app.public_url="https://bemestarnotrabalho.santacasa.org.br"',
      'smtp.clientname="Conexão Santa Casa"',
    ],
  },
  'telemed-hcor': {
    firebaseConfig: {
      apiKey: 'AIzaSyC4NrvoCvn8yjKzuNQ3_OIm7zHWbTRklm4',
      authDomain: 'telemed-hcor.firebaseapp.com',
      databaseURL: 'https://telemed-hcor.firebaseio.com',
      projectId: 'telemed-hcor',
      storageBucket: 'telemed-hcor.appspot.com',
      messagingSenderId: '390879571822',
      appId: '1:390879571822:web:f9d2172318875e44c95b7f',
      measurementId: 'G-ZBXK72TPSV',
    },
    functionsConfig: [
      'app.public_url="https://hcordigital.com.br"',
      'smtp.clientname="HCOR Digital"',
    ],
  },
  // --------- DAQUI PRA BAIXO É TUDO MEDICINA DIRETA ---------
  'telemed-medireta': {
    firebaseConfig: {
      apiKey: 'AIzaSyCyLCupmsoDp3iOBre7EKeBLw5pwoaKlKM',
      authDomain: 'telemed-medireta.firebaseapp.com',
      databaseURL: 'https://telemed-medireta.firebaseio.com',
      projectId: 'telemed-medireta',
      storageBucket: 'telemed-medireta.appspot.com',
      messagingSenderId: '1086530250907',
      appId: '1:1086530250907:web:108f0ab3062475dfd1fe3e',
      measurementId: 'G-M68HGZLG8M',
    },
    functionsConfig: [
      'app.public_url="https://medicinadireta.telemedicina.drtis.com.br"',
      'smtp.clientname="Medicina Direta"',
    ],
  },
  'telemed-inreuma': {
    firebaseConfig: {
      apiKey: 'AIzaSyDhczGDeCgXNfBkm_dG1BYQn0jGIxF_itw',
      authDomain: 'telemed-inreuma.firebaseapp.com',
      databaseURL: 'https://telemed-inreuma.firebaseio.com',
      projectId: 'telemed-inreuma',
      storageBucket: 'telemed-inreuma.appspot.com',
      messagingSenderId: '1040653088194',
      appId: '1:1040653088194:web:bb2d097a5173071ea1d25b',
      measurementId: 'G-E5K5WS5EJY',
    },
    functionsConfig: [
      'app.public_url="https://inreuma.telemedicina.drtis.com.br"',
      'smtp.clientname="inReuma"',
    ],
  },
  'telemed-mariamonte': {
    firebaseConfig: {
      apiKey: 'AIzaSyA0-yz0lL0TzEa6MLIDCn7kwNaVTZs16NA',
      authDomain: 'telemed-mariamonte.firebaseapp.com',
      databaseURL: 'https://telemed-mariamonte.firebaseio.com',
      projectId: 'telemed-mariamonte',
      storageBucket: 'telemed-mariamonte.appspot.com',
      messagingSenderId: '956197153012',
      appId: '1:956197153012:web:1439cb24c1d1587c6a56a1',
      measurementId: 'G-587KD57M9Z',
    },
    functionsConfig: [
      'app.public_url="https://mariamontenegro.drtis.com.br"',
      'smtp.clientname="Dra. Maria Montenegro"',
    ],
  },
  'telemed-marlafrancisca': {
    firebaseConfig: {
      apiKey: 'AIzaSyAF7RmyOjC18SwtByweWS4xgWzuLbqxdPk',
      authDomain: 'telemed-marlafrancisca.firebaseapp.com',
      databaseURL: 'https://telemed-marlafrancisca.firebaseio.com',
      projectId: 'telemed-marlafrancisca',
      storageBucket: 'telemed-marlafrancisca.appspot.com',
      messagingSenderId: '546316182501',
      appId: '1:546316182501:web:8283cf6c7813ad601d450c',
      measurementId: 'G-DHJZP0WKMR',
    },
    functionsConfig: [
      'app.public_url="https://marlafrancisca.drtis.com.br"',
      'smtp.clientname="Dra. Marla Francisca"',
    ],
  },
  'telemed-hudanoujaim': {
    firebaseConfig: {
      apiKey: 'AIzaSyBTJ29Bo0ClvKYqqEGy2oPSgdMdcQ_Ku1Q',
      authDomain: 'telemed-hudanoujaim.firebaseapp.com',
      databaseURL: 'https://telemed-hudanoujaim.firebaseio.com',
      projectId: 'telemed-hudanoujaim',
      storageBucket: 'telemed-hudanoujaim.appspot.com',
      messagingSenderId: '307095000969',
      appId: '1:307095000969:web:abcb92db9266c3b6437358',
      measurementId: 'G-784PRTXZVX',
    },
    functionsConfig: [
      'app.public_url="https://hudanoujaim.drtis.com.br"',
      'smtp.clientname="Dra. Huda"',
    ],
  },
  'telemed-elianebastos': {
    firebaseConfig: {
      apiKey: 'AIzaSyBv6B_flxckbA92L7d5SKOhOsIeZE57wrw',
      authDomain: 'telemed-elianebastos.firebaseapp.com',
      databaseURL: 'https://telemed-elianebastos.firebaseio.com',
      projectId: 'telemed-elianebastos',
      storageBucket: 'telemed-elianebastos.appspot.com',
      messagingSenderId: '928503275205',
      appId: '1:928503275205:web:27bbcdd9bf4cd058eb9aac',
      measurementId: 'G-93P8NZQZP2',
    },
    functionsConfig: [
      'app.public_url="https://elianebastos.drtis.com.br"',
      'smtp.clientname="Dra. Eliane Bastos"',
    ],
  },
  'telemed-geilsonsantana': {
    firebaseConfig: {
      apiKey: 'AIzaSyBgSP3mcf3HWZxS4P23GiDZGOEcgsPPCB0',
      authDomain: 'telemed-geilsonsantana.firebaseapp.com',
      databaseURL: 'https://telemed-geilsonsantana.firebaseio.com',
      projectId: 'telemed-geilsonsantana',
      storageBucket: 'telemed-geilsonsantana.appspot.com',
      messagingSenderId: '390282086397',
      appId: '1:390282086397:web:e817d4f2c4000bc0263b94',
      measurementId: 'G-1W4KNCBLJG',
    },
    functionsConfig: [
      'app.public_url="https://drgeilsonsantana.drtis.com.br"',
      'smtp.clientname="Dr. Geilson Santana"',
    ],
  },
  'telemed-draltamiro': {
    firebaseConfig: {
      apiKey: 'AIzaSyC6WAZJ7pFoqxtkGeD2ho9KzD9V5xAK9Ko',
      authDomain: 'telemed-draltamiro.firebaseapp.com',
      databaseURL: 'https://telemed-draltamiro.firebaseio.com',
      projectId: 'telemed-draltamiro',
      storageBucket: 'telemed-draltamiro.appspot.com',
      messagingSenderId: '419713592038',
      appId: '1:419713592038:web:2f2e379feff241ac86e927',
      measurementId: 'G-0YTM6D6HYQ',
    },
    functionsConfig: [
      'app.public_url="https://draltamiro.drtis.com.br"',
      'smtp.clientname="Dr. Altamiro"',
    ],
  },
  'telemed-vcaf': {
    firebaseConfig: {
      apiKey: 'AIzaSyDRNfeZ4R23617oUoiaNhTINPvH3FHJUj4',
      authDomain: 'telemed-vcaf.firebaseapp.com',
      databaseURL: 'https://telemed-vcaf.firebaseio.com',
      projectId: 'telemed-vcaf',
      storageBucket: 'telemed-vcaf.appspot.com',
      messagingSenderId: '456304298093',
      appId: '1:456304298093:web:653475e2e891821ce85764',
      measurementId: 'G-FD79CK9KN7',
    },
    functionsConfig: [
      'app.public_url="https://vcaf.drtis.com.br"',
      'smtp.clientname="VCAF"',
    ],
  },
  'telemed-dentcare': {
    firebaseConfig: {
      apiKey: 'AIzaSyB_aDFt2CZMRW_ksqGGAt9dTuAxFUpxkRE',
      authDomain: 'telemed-dentcare.firebaseapp.com',
      databaseURL: 'https://telemed-dentcare.firebaseio.com',
      projectId: 'telemed-dentcare',
      storageBucket: 'telemed-dentcare.appspot.com',
      messagingSenderId: '184767610471',
      appId: '1:184767610471:web:437ffc8951f262f3d25ec2',
      measurementId: 'G-BZPZPKV4WB',
    },
    functionsConfig: [
      'app.public_url="https://dentcarecenter.drtis.com.br"',
      'smtp.clientname="Clínica DentCare Center"',
    ],
  },
  'telemed-solangemalfacini': {
    firebaseConfig: {
      apiKey: 'AIzaSyCmeX-24W7NgXwqcL4gry6kf3CbR3PIqtY',
      authDomain: 'telemed-solangemalfacini.firebaseapp.com',
      databaseURL: 'https://telemed-solangemalfacini.firebaseio.com',
      projectId: 'telemed-solangemalfacini',
      storageBucket: 'telemed-solangemalfacini.appspot.com',
      messagingSenderId: '595590257233',
      appId: '1:595590257233:web:6318d3a811244bd2f2f670',
      measurementId: 'G-MBY1RV08SQ',
    },
    functionsConfig: [
      'app.public_url="https://solangemalfacini.drtis.com.br"',
      'smtp.clientname="Dra. Solange Malfacini"',
    ],
  },
  'telemed-trf5': {
    firebaseConfig: {
      apiKey: 'AIzaSyBjTCMs_emqzt_KDi7s-QJsLNlIZGVS0Cg',
      authDomain: 'telemed-trf5.firebaseapp.com',
      projectId: 'telemed-trf5',
      storageBucket: 'telemed-trf5.appspot.com',
      messagingSenderId: '656355203974',
      appId: '1:656355203974:web:a6726efa076d062fdb2a07',
      measurementId: 'G-996TPYS378',
    },
    functionsConfig: [
      'app.public_url="https://trf5.drtis.com.br"',
      'smtp.clientname="TRF5 - CAIS DO APOLO"',
    ],
  },
  'telemed-jfpe': {
    firebaseConfig: {
      apiKey: 'AIzaSyDsMWOLoLr1Ry3vzN-v-VIoj-eLmsyVgO8',
      authDomain: 'telemed-jfpe.firebaseapp.com',
      projectId: 'telemed-jfpe',
      storageBucket: 'telemed-jfpe.appspot.com',
      messagingSenderId: '488739264894',
      appId: '1:488739264894:web:b5bde4fb6138f60fd0fb2f',
      measurementId: 'G-JSQ9ZQ8X9N',
    },
    functionsConfig: [
      'app.public_url="https://jfpe.drtis.com.br"',
      'smtp.clientname="TRF5 - SJ PERNAMBUCO"',
    ],
  },
  'telemed-jfrn': {
    firebaseConfig: {
      apiKey: 'AIzaSyAEAskcFm-caWL6EZHdM6gfF3LPWWoQu8g',
      authDomain: 'telemed-jfrn.firebaseapp.com',
      projectId: 'telemed-jfrn',
      storageBucket: 'telemed-jfrn.appspot.com',
      messagingSenderId: '378311810475',
      appId: '1:378311810475:web:a74817faf4b9aca04106ee',
      measurementId: 'G-DETF3T9S0M',
    },
    functionsConfig: [
      'app.public_url="https://jfrn.drtis.com.br"',
      'smtp.clientname="TRF5 - SJ RIO GRANDE DO NORTE"',
    ],
  },
  'telemed-jfpb': {
    firebaseConfig: {
      apiKey: 'AIzaSyC5VWDtNxzAs9hBzH-yuWDNfiEqV6WPiHk',
      authDomain: 'telemed-jfpb.firebaseapp.com',
      projectId: 'telemed-jfpb',
      storageBucket: 'telemed-jfpb.appspot.com',
      messagingSenderId: '1007529463813',
      appId: '1:1007529463813:web:c54209c8eabc7c9826cc6c',
      measurementId: 'G-L89GRFQKBF',
    },
    functionsConfig: [
      'app.public_url="https://jfpb.drtis.com.br"',
      'smtp.clientname="TRF5 - SJ PARAÍBA"',
    ],
  },
  'telemed-jfal': {
    firebaseConfig: {
      apiKey: 'AIzaSyBiJ_IfkUtSvr8QDYamqaCby4b5Vgg0Thk',
      authDomain: 'telemed-jfal.firebaseapp.com',
      projectId: 'telemed-jfal',
      storageBucket: 'telemed-jfal.appspot.com',
      messagingSenderId: '336614574712',
      appId: '1:336614574712:web:7c76422cea9fd489bafb8d',
      measurementId: 'G-FMM322RN7N',
    },
    functionsConfig: [
      'app.public_url="https://jfal.drtis.com.br"',
      'smtp.clientname="TRF5 - SJ ALAGOAS"',
    ],
  },
  'telemed-jfse': {
    firebaseConfig: {
      apiKey: 'AIzaSyBJxKUdgymfi5QMn6vUsgnPVoDG6gua7Uk',
      authDomain: 'telemed-jfse.firebaseapp.com',
      projectId: 'telemed-jfse',
      storageBucket: 'telemed-jfse.appspot.com',
      messagingSenderId: '597965149692',
      appId: '1:597965149692:web:6ca8eaba85f8c7888d0e79',
      measurementId: 'G-P610YV66ZP',
    },
    functionsConfig: [
      'app.public_url="https://jfse.drtis.com.br"',
      'smtp.clientname="TRF5 - SJ SERGIPE"',
    ],
  },
  'telemed-jfce': {
    firebaseConfig: {
      apiKey: 'AIzaSyC55I2qaC9MkJv9ich2_CEWh5fUaf7kkfE',
      authDomain: 'telemed-jfce.firebaseapp.com',
      databaseURL: 'https://telemed-jfce-default-rtdb.firebaseio.com',
      projectId: 'telemed-jfce',
      storageBucket: 'telemed-jfce.appspot.com',
      messagingSenderId: '435363646634',
      appId: '1:435363646634:web:0cdddbc14baffb7c4594d3',
      measurementId: 'G-FGY6ZBSYR6',
    },
    functionsConfig: [
      'app.public_url="https://jfce.drtis.com.br"',
      'smtp.clientname="TRF5 - SJ CEARÁ"',
    ],
  },
  'telemed-roseliandrade': {
    firebaseConfig: {
      apiKey: 'AIzaSyCck5RysssbdpA0MY32Njfa0gv1QwU6Z1I',
      authDomain: 'telemed-roseliandrade.firebaseapp.com',
      projectId: 'telemed-roseliandrade',
      storageBucket: 'telemed-roseliandrade.appspot.com',
      messagingSenderId: '1005384922299',
      appId: '1:1005384922299:web:f0614545492687c1fda59e',
      measurementId: 'G-S8CBQ000LV',
    },
    functionsConfig: [
      'app.public_url="https://draroseliandrade.drtis.com.br"',
      'smtp.clientname="Clínica Dermatológica Dra Roseli Andrade"',
    ],
  },
  // --------- DAQUI PRA CIMA É TUDO MEDICINA DIRETA ---------
  // --------- DAQUI PRA BAIXO É TUDO GRUPO SANTA CATARINA ---------
  'telemed-santacatarina': {
    firebaseConfig: {
      apiKey: 'AIzaSyBzaKnV9p24ynEX6G8AeJ_Jt0RLKeWFFDA',
      authDomain: 'telemed-santacatarina.firebaseapp.com',
      databaseURL: 'https://telemed-santacatarina.firebaseio.com',
      projectId: 'telemed-santacatarina',
      storageBucket: 'telemed-santacatarina.appspot.com',
      messagingSenderId: '257878983344',
      appId: '1:257878983344:web:ddc22d1907559f4d577175',
      measurementId: 'G-CR939DG1FX',
    },
    functionsConfig: [
      'app.public_url="https://santacatarina.drtis.com.br"',
      'smtp.clientname="Santa Catarina"',
    ],
  },
  'telemed-stacathomolog': {
    firebaseConfig: {
      apiKey: 'AIzaSyCwFs7DdGSyf0tIGRSiOXRW9BHRE5tp2ts',
      authDomain: 'telemed-stacathomolog.firebaseapp.com',
      databaseURL: 'https://telemed-stacathomolog.firebaseio.com',
      projectId: 'telemed-stacathomolog',
      storageBucket: 'telemed-stacathomolog.appspot.com',
      messagingSenderId: '386426759865',
      appId: '1:386426759865:web:12e4bbdae1dfe6f5a54968',
      measurementId: 'G-E044XC41LR',
    },
    functionsConfig: [
      'app.public_url="https://santacatarinahomologacao.drtis.com.br"',
      'smtp.clientname="Santa Catarina"',
      'elastic.url="https://cache.telemedicina.drtis.com.br"',
    ],
  },
  // --------- DAQUI PRA CIMA É TUDO GRUPO SANTA CATARINA -----------------
  'telemed-sepaco': {
    firebaseConfig: {
      apiKey: 'AIzaSyDohBuZRzXp_nbgyhdKgX6p1y5A76594NA',
      authDomain: 'telemed-sepaco.firebaseapp.com',
      databaseURL: 'https://telemed-sepaco.firebaseio.com',
      projectId: 'telemed-sepaco',
      storageBucket: 'telemed-sepaco.appspot.com',
      messagingSenderId: '478349299781',
      appId: '1:478349299781:web:9bd08147af3222b73b132c',
      measurementId: 'G-PR3MHYV1MX',
    },
    functionsConfig: [
      'app.public_url="https://sepaco.drtis.com.br"',
      'smtp.clientname="Sepaco"',
    ],
  },
  'telemed-vitalmed': {
    firebaseConfig: {
      apiKey: 'AIzaSyBy5jTc3PSFAgQCMuMJoYrqPlJGm22Fgy0',
      authDomain: 'telemed-vitalmed.firebaseapp.com',
      databaseURL: 'https://telemed-vitalmed.firebaseio.com',
      projectId: 'telemed-vitalmed',
      storageBucket: 'telemed-vitalmed.appspot.com',
      messagingSenderId: '498619568628',
      appId: '1:498619568628:web:43fcf677c61e12176da9a1',
      measurementId: 'G-6YL3Y330PB',
    },
    functionsConfig: [
      'app.public_url="https://vitalmed.drtis.com.br"',
      'smtp.clientname="VitalMed"',
    ],
  },
  'telemed-materdei': {
    firebaseConfig: {
      apiKey: 'AIzaSyAKjOKO1FGcUFUCYYBL22scmcjEWAOyL4M',
      authDomain: 'telemed-materdei.firebaseapp.com',
      databaseURL: 'https://telemed-materdei.firebaseio.com',
      projectId: 'telemed-materdei',
      storageBucket: 'telemed-materdei.appspot.com',
      messagingSenderId: '122313548683',
      appId: '1:122313548683:web:a8d1158269485bd494458e',
      measurementId: 'G-6LP5QV4K7C',
    },
    functionsConfig: [
      'app.public_url="https://materdei.drtis.com.br"',
      'smtp.clientname="MaterDei"',
    ],
  },
  'telemed-homologmaterdei': {
    firebaseConfig: {
      apiKey: 'AIzaSyCCDW2bTKwTrOqUeZSO7u7EvH0PcBCOwe4',
      authDomain: 'telemed-homologmaterdei.firebaseapp.com',
      projectId: 'telemed-homologmaterdei',
      storageBucket: 'telemed-homologmaterdei.appspot.com',
      messagingSenderId: '805949645756',
      appId: '1:805949645756:web:84574a02cfaccf194141b9',
      measurementId: 'G-1DVRJ8VS2F',
    },
    functionsConfig: [
      'app.public_url="https://teste-materdei.drtis.com.br"',
      'smtp.clientname="Teste MaterDei"',
    ],
  },
  'telemed-helpmovel': {
    firebaseConfig: {
      apiKey: 'AIzaSyAhtbBhVONEYKh-gGDKRBMblf1mYQ3pkc4',
      authDomain: 'telemed-helpmovel.firebaseapp.com',
      projectId: 'telemed-helpmovel',
      storageBucket: 'telemed-helpmovel.appspot.com',
      messagingSenderId: '131251246326',
      appId: '1:131251246326:web:9203d4966c321cd5af08d7',
      measurementId: 'G-Y97Q935NZF',
    },
    functionsConfig: [
      'app.public_url="https://drhelpmovel.com.br"',
      'smtp.clientname="Help Móvel"',
    ],
  },
  'telemed-ostermed': {
    firebaseConfig: {
      apiKey: 'AIzaSyCl455vyHWfrp2F4K9C1lX4XDZHkvYhd2g',
      authDomain: 'telemed-ostermed.firebaseapp.com',
      projectId: 'telemed-ostermed',
      storageBucket: 'telemed-ostermed.appspot.com',
      messagingSenderId: '985929454795',
      appId: '1:985929454795:web:5b2c38a8787317467a774e',
      measurementId: 'G-STGMQ1NB2J',
    },
    functionsConfig: [
      'app.public_url="https://ostermed.drtis.com.br"',
      'smtp.clientname="Ostermed"',
    ],
  },
  'telemed-unimedvtrp': {
    firebaseConfig: {
      apiKey: 'AIzaSyA7c9xmBwMWvOryQltyOsi6avOcLYc6FcA',
      authDomain: 'telemed-unimedvtrp.firebaseapp.com',
      projectId: 'telemed-unimedvtrp',
      storageBucket: 'telemed-unimedvtrp.appspot.com',
      messagingSenderId: '844692277958',
      appId: '1:844692277958:web:e7abbfec270a55e8d165c7',
      measurementId: 'G-X5N5CJC481',
    },
    functionsConfig: [
      'app.public_url="https://unimedvtrp.drtis.com.br"',
      'smtp.clientname="Unimed VTRP"',
    ],
  },
  'telemed-medlivre': {
    firebaseConfig: {
      apiKey: 'AIzaSyDASb_5XsW_KAJOroBybyCC2jtLrPrwpHU',
      authDomain: 'telemed-medlivre.firebaseapp.com',
      projectId: 'telemed-medlivre',
      storageBucket: 'telemed-medlivre.appspot.com',
      messagingSenderId: '838457356893',
      appId: '1:838457356893:web:0940a56111c39e1a6493b4',
      measurementId: 'G-5SG5NMKTNC',
    },
    functionsConfig: [
      'app.public_url="https://medlivre.drtis.com.br"',
      'smtp.clientname="MedLivre Tecnologia da Informação Ltda"',
    ],
  },
  'telemed-ring': {
    firebaseConfig: {
      apiKey: 'AIzaSyBV_c--1DDasdpn5ECuXbUcMs4iC8Pm9pE',
      authDomain: 'telemed-ring.firebaseapp.com',
      projectId: 'telemed-ring',
      storageBucket: 'telemed-ring.appspot.com',
      messagingSenderId: '281769134768',
      appId: '1:281769134768:web:81076a4187ecb2bbd68975',
      measurementId: 'G-FXFHEBZRF3',
    },
    functionsConfig: [
      'app.public_url="https://draana.sramospsiquiatra.drtis.com.br"',
      'smtp.clientname="Ring Serviços Médicos Eireli"',
    ],
  },
  'telemed-mediall': {
    firebaseConfig: {
      apiKey: 'AIzaSyButIltZihLxUSAOQRuGZdgyyr-p-q_KWw',
      authDomain: 'telemed-mediall.firebaseapp.com',
      projectId: 'telemed-mediall',
      storageBucket: 'telemed-mediall.appspot.com',
      messagingSenderId: '803748086865',
      appId: '1:803748086865:web:36edefb852ebf05d482470',
      measurementId: 'G-DXXLVF9RY1',
    },
    functionsConfig: [
      'app.public_url="https://mediall.drtis.com.br"',
      'smtp.clientname="Mediall Brasil"',
    ],
  },
  'telemed-pfpv': {
    firebaseConfig: {
      apiKey: 'AIzaSyDPUMcVX4yI11eCEjK_AzBWJQf7am8AXxw',
      authDomain: 'telemed-pfpv.firebaseapp.com',
      projectId: 'telemed-pfpv',
      storageBucket: 'telemed-pfpv.appspot.com',
      messagingSenderId: '694290889831',
      appId: '1:694290889831:web:16f967c3b562710086e8c2',
      measurementId: 'G-LS5VGCQ6FR',
    },
    functionsConfig: [
      'app.public_url="https://pfpv.drtis.com.br"',
      'smtp.clientname="Penitenciária Federal em Porto Velho"',
    ],
  },
  'telemed-pfmos': {
    firebaseConfig: {
      apiKey: 'AIzaSyCtp2PQDpYnuzmfMwgr0mhC1Z4MiO0UURA',
      authDomain: 'telemed-pfmos.firebaseapp.com',
      projectId: 'telemed-pfmos',
      storageBucket: 'telemed-pfmos.appspot.com',
      messagingSenderId: '660228331621',
      appId: '1:660228331621:web:8bcc2525172faf36d40e8c',
      measurementId: 'G-HSVK3DQKEN',
    },
    functionsConfig: [
      'app.public_url="https://pfmos.drtis.com.br"',
      'smtp.clientname="Penitenciária Federal em Mossoró"',
    ],
  },
  'telemed-pfcg': {
    firebaseConfig: {
      apiKey: 'AIzaSyCFpcVNJESxuOKooDvYyofYEdM8WwGOTck',
      authDomain: 'telemed-pfcg.firebaseapp.com',
      projectId: 'telemed-pfcg',
      storageBucket: 'telemed-pfcg.appspot.com',
      messagingSenderId: '473987997913',
      appId: '1:473987997913:web:d17b3f40a2b06f75ba9ec8',
      measurementId: 'G-4F63CRR4J2',
    },
    functionsConfig: [
      'app.public_url="https://pfcg.drtis.com.br"',
      'smtp.clientname="Penitenciária Federal em Campo Grande"',
    ],
  },
  'telemed-pfcat': {
    firebaseConfig: {
      apiKey: 'AIzaSyBwmkAwXzUR8sa0RM5unQuSdvKkR945u00',
      authDomain: 'telemed-pfcat.firebaseapp.com',
      projectId: 'telemed-pfcat',
      storageBucket: 'telemed-pfcat.appspot.com',
      messagingSenderId: '940940339940',
      appId: '1:940940339940:web:c3454fc9aaf85722c09af1',
      measurementId: 'G-EX7Z96GWD0',
    },
    functionsConfig: [
      'app.public_url="https://pfcat.drtis.com.br"',
      'smtp.clientname="Penitenciária Federal em Catanduvas"',
    ],
  },
  'telemed-pfbra': {
    firebaseConfig: {
      apiKey: 'AIzaSyAcjmcjsx1G4jzaorebXJ22lwF1M1yfxyY',
      authDomain: 'telemed-pfbra.firebaseapp.com',
      projectId: 'telemed-pfbra',
      storageBucket: 'telemed-pfbra.appspot.com',
      messagingSenderId: '137991123674',
      appId: '1:137991123674:web:1826ea4605c76b7e06abe3',
      measurementId: 'G-S5MH7V2N3D',
    },
    functionsConfig: [
      'app.public_url="https://pfbra.drtis.com.br"',
      'smtp.clientname="Penitenciária Federal em Brasília"',
    ],
  },
  'telemed-unimedvtrphomolog': {
    firebaseConfig: {
      apiKey: 'AIzaSyCD6f9-fm6uqD9rThnyXxuy9smkpU1N7kw',
      authDomain: 'telemed-unimedvtrphomolog.firebaseapp.com',
      projectId: 'telemed-unimedvtrphomolog',
      storageBucket: 'telemed-unimedvtrphomolog.appspot.com',
      messagingSenderId: '970873269157',
      appId: '1:970873269157:web:f6861ccc9e2db276ad564c',
      measurementId: 'G-FZ5DNCHC5T',
    },
    functionsConfig: [
      'app.public_url="https://homolog.unimedvtrp.drtis.com.br"',
      'smtp.clientname="Homolog VTRP"',
    ],
  },
  'telemed-teleuti': {
    firebaseConfig: {
      apiKey: 'AIzaSyCaLMmOSW3w_xaU0BRuRwX9t-7txjsWCnA',
      authDomain: 'telemed-teleuti.firebaseapp.com',
      projectId: 'telemed-teleuti',
      storageBucket: 'telemed-teleuti.appspot.com',
      messagingSenderId: '19240908360',
      appId: '1:19240908360:web:c4239cfbb78bf8e08e4a7d',
      measurementId: 'G-R03D94CP5M',
    },
    functionsConfig: [
      'app.public_url="https://teleuti.drtis.com.br"',
      'smtp.clientname="TeleUTI"',
    ],
  },
  'telemed-institutohellis': {
    firebaseConfig: {
      apiKey: 'AIzaSyCFjaKxAgOSPVDKxENIcwZaMFtjR0pw2Q0',
      authDomain: 'telemed-institutohellis.firebaseapp.com',
      projectId: 'telemed-institutohellis',
      storageBucket: 'telemed-institutohellis.appspot.com',
      messagingSenderId: '906597325672',
      appId: '1:906597325672:web:0c5f405978d5c5a5c0d4dd',
      measurementId: 'G-YBXNQHXVSB',
    },
    functionsConfig: [
      'app.public_url="https://institutohellis.drtis.com.br"',
      'smtp.clientname="Instituto H.Ellis Serviços Médicos S/S"',
    ],
  },
  'telemed-homolccg': {
    firebaseConfig: {
      apiKey: 'AIzaSyDj6KGbMO9NwCGsjGWfFHd0jYAyD2JO2Kc',
      authDomain: 'telemed-homologccg.firebaseapp.com',
      projectId: 'telemed-homologccg',
      storageBucket: 'telemed-homologccg.appspot.com',
      messagingSenderId: '1086415540826',
      appId: '1:1086415540826:web:fc1a18d59fc7e769967e63',
      measurementId: 'G-MZ0VD23TGY',
    },
    functionsConfig: [
      'app.public_url=\"https://homologccg.drtis.com.br\"',
      'smtp.clientname=\"Homologação CCG\"',
    ],
  },
  'telemed-pedilar': {
    firebaseConfig: {
      apiKey: 'AIzaSyCTdMDEN-bi_eKeaPRJ26fGdvxeotNbt68',
      authDomain: 'telemed-pedilar.firebaseapp.com',
      projectId: 'telemed-pedilar',
      storageBucket: 'telemed-pedilar.appspot.com',
      messagingSenderId: '141721372748',
      appId: '1:141721372748:web:c8d27651726ce292ab4ce9',
      measurementId: 'G-DNNNVGGTSR',
    },
    functionsConfig: [
      'app.public_url="https://pedilar.drtis.com.br"',
      'smtp.clientname="Pedilar Ltda"',
    ],
  },
  'telemed-vitahomecare': {
    firebaseConfig: {
      apiKey: 'AIzaSyAd_4wITw1FZwAfw2Z8QjIeBfvqKc4iJvA',
      authDomain: 'telemed-vitahomecare.firebaseapp.com',
      projectId: 'telemed-vitahomecare',
      storageBucket: 'telemed-vitahomecare.appspot.com',
      messagingSenderId: '169538533897',
      appId: '1:169538533897:web:6431971c19d22763e6d6d8',
      measurementId: 'G-G6CGBPP25J',
    },
    functionsConfig: [
      'app.public_url="https://vitahomecare.drtis.com.br"',
      'smtp.clientname="Vita Home Care"',
    ],
  },
  'telemed-clinicapluris': {
    firebaseConfig: {
      apiKey: 'AIzaSyCzz2rin41XTx7oTTd-SjpDBEYeemjAULU',
      authDomain: 'telemed-clinicapluris.firebaseapp.com',
      projectId: 'telemed-clinicapluris',
      storageBucket: 'telemed-clinicapluris.appspot.com',
      messagingSenderId: '529260926131',
      appId: '1:529260926131:web:71be662f8d27cf85c68cc6',
      measurementId: 'G-64SFCSXW1W',
    },
    functionsConfig: [
      'app.public_url="https://clinicapluris.drtis.com.br"',
      'smtp.clientname="Clinica Pluris Ltda"',
    ],
  },
  'telemed-imeclinicacidada': {
    firebaseConfig: {
      apiKey: 'AIzaSyDjFQmixk_2OjgOjjmpoYdmUoPwuUimK6s',
      authDomain: 'telemed-imeclinicacidada.firebaseapp.com',
      projectId: 'telemed-imeclinicacidada',
      storageBucket: 'telemed-imeclinicacidada.appspot.com',
      messagingSenderId: '877685541371',
      appId: '1:877685541371:web:3d813341467165037ea35e',
      measurementId: 'G-HY6EGJK6DE',
    },
    functionsConfig: [
      'app.public_url="https://telemedicina.imeclinicacidada.com.br"',
      'smtp.clientname="Ime Clinica Cidadã"',
    ],
  },
  'telemed-impulssesaude': {
    firebaseConfig: {
      apiKey: 'AIzaSyBJwSbiDh7vZz7-hpaF65dSX81_LqhJCtk',
      authDomain: 'telemed-impulssesaude.firebaseapp.com',
      projectId: 'telemed-impulssesaude',
      storageBucket: 'telemed-impulssesaude.appspot.com',
      messagingSenderId: '827616422918',
      appId: '1:827616422918:web:41dd8abeb76b4bc5e6a787',
      measurementId: 'G-ZT76FVV1Y9',
    },
    functionsConfig: [
      'app.public_url=\"https://impulssesaude.drtis.com.br\"',
      'smtp.clientname=\"Impulsse Soluções em Saúde\"',
    ],
  },
  'telemed-ijc': {
    firebaseConfig: {
      apiKey: 'AIzaSyBjExPAl-Fix9FJCTyCc_FnCBAVzL0k2QA',
      authDomain: 'telemed-ijc.firebaseapp.com',
      projectId: 'telemed-ijc',
      storageBucket: 'telemed-ijc.appspot.com',
      messagingSenderId: '119627812176',
      appId: '1:119627812176:web:441f9c1b05d03ec7a67055',
      measurementId: 'G-1XJ8358G9H',
    },
    functionsConfig: [
      'app.public_url=\"https://ijc.drtis.com.br\"',
      'smtp.clientname=\"Instituto João Clemente\"',
    ],
  },
  'telemed-consultare': {
    firebaseConfig: {
      apiKey: 'AIzaSyBLFTfa_Iuiecy-NXkDhC8wncsOheolmNI',
      authDomain: 'telemed-consultare.firebaseapp.com',
      projectId: 'telemed-consultare',
      storageBucket: 'telemed-consultare.appspot.com',
      messagingSenderId: '41331464808',
      appId: '1:41331464808:web:915a9f822144c66b83f9dd',
      measurementId: 'G-35GY5FEC9Y',
    },
    functionsConfig: [
      'app.public_url="https://consultare.drtis.com.br"',
      'smtp.clientname="Consultare"',
    ],
  },
  'telemed-sma': {
    firebaseConfig: {
      apiKey: 'AIzaSyC-l4g_TNbsP5Rkb3ac2quc-Yi7DLor8mY',
      authDomain: 'telemed-sma.firebaseapp.com',
      databaseURL: 'https://telemed-sma-default-rtdb.firebaseio.com',
      projectId: 'telemed-sma',
      storageBucket: 'telemed-sma.appspot.com',
      messagingSenderId: '968960439027',
      appId: '1:968960439027:web:4a41a323e0f691bb9b7d86',
      measurementId: 'G-GSZ810NBNP',
    },
    functionsConfig: [
      'app.public_url="https://sma.drtis.com.br"',
      'smtp.clientname="SMA"',
    ],
  },
  'telemed-saomiguel': {
    firebaseConfig: {
      apiKey: 'AIzaSyBBE-U3RMZW0-qHPzUj6oFzwrGBUInh0SQ',
      authDomain: 'telemed-saomiguel.firebaseapp.com',
      projectId: 'telemed-saomiguel',
      storageBucket: 'telemed-saomiguel.appspot.com',
      messagingSenderId: '1035250755432',
      appId: '1:1035250755432:web:602ee2ec38fc2c7bd098dd',
      measurementId: 'G-460DHYKR6F',
    },
    functionsConfig: [
      'app.public_url=\"https://saomiguelsaude.drtis.com.br\"',
      'smtp.clientname=\"São Miguel Saúde\"',
    ],
  },
  'telemed-santacasabh': {
    firebaseConfig: {
      apiKey: 'AIzaSyBYta59h7Y56W2ak_Aosg-Vq_hfJ1jHZ7s',
      authDomain: 'telemed-santacasabh.firebaseapp.com',
      projectId: 'telemed-santacasabh',
      storageBucket: 'telemed-santacasabh.appspot.com',
      messagingSenderId: '726881828634',
      appId: '1:726881828634:web:2bc782f37d08c185cab6a3',
      measurementId: 'G-1R27P5V4VV',
    },
    functionsConfig: [
      'app.public_url=\"https://santacasabh.drtis.com.br\"',
      'smtp.clientname=\"Santa Casa de Misericórdia de Belo Horizonte\"',
    ],
  },
  'telemed-vitalmedhomologacao': {
    firebaseConfig: {
      apiKey: 'AIzaSyAfhbQlCTYcfzf8s_K3qoq9DsTrHAJ9AcI',
      authDomain: 'telemed-vitalmedhomologacao.firebaseapp.com',
      projectId: 'telemed-vitalmedhomologacao',
      storageBucket: 'telemed-vitalmedhomologacao.appspot.com',
      messagingSenderId: '752094518644',
      appId: '1:752094518644:web:797bb25f3993951ddba021',
      measurementId: 'G-D6XVTVWPBG',
    },
    functionsConfig: [
      'app.public_url="https://vitalmedhomologacao.drtis.com.br"',
      'smtp.clientname="Homologação Vitalmed"',
    ],
  },
  'telemed-helpmovelpiracicaba': {
    firebaseConfig: {
      apiKey: 'AIzaSyChf89dZ63h9NLDMAg9mPX-GYSrZ9BqyXY',
      authDomain: 'telemed-helpmovelpiracicaba.firebaseapp.com',
      projectId: 'telemed-helpmovelpiracicaba',
      storageBucket: 'telemed-helpmovelpiracicaba.appspot.com',
      messagingSenderId: '962714898612',
      appId: '1:962714898612:web:f6699e8c3182a1564507e1',
      measurementId: 'G-JXNC7T0TTM',
    },
    functionsConfig: [
      'app.public_url="https://helpmovelpiracicaba.drtis.com.br"',
      'smtp.clientname="Help Móvel Piracicaba"',
    ],
  },
  'telemed-enterprisehealth': {
    firebaseConfig: {
      apiKey: 'AIzaSyDaBGs3EW5WLWqV-EXi0WMs54JsSjhOLzI',
      authDomain: 'telemed-enterprisehealth.firebaseapp.com',
      projectId: 'telemed-enterprisehealth',
      storageBucket: 'telemed-enterprisehealth.appspot.com',
      messagingSenderId: '96508211379',
      appId: '1:96508211379:web:23f42573ceec5bb19a00c6',
      measurementId: 'G-QJT94WL3BV',
    },
    functionsConfig: [
      'app.public_url=\"https://enterprisehealth.drtis.com.br\"',
      'smtp.clientname=\"Enterprise Health\"',
    ],
  },
  'telemed-evolue': {
    firebaseConfig: {
      apiKey: 'AIzaSyDP19iN3Fwhu68pUTd9WH-O0hugPQRq8h4',
      authDomain: 'telemed-evolue.firebaseapp.com',
      projectId: 'telemed-evolue',
      storageBucket: 'telemed-evolue.appspot.com',
      messagingSenderId: '347623365039',
      appId: '1:347623365039:web:25590964f35cc21e65b75a',
      measurementId: 'G-85Z8T1XK9S',
    },
    functionsConfig: [
      'app.public_url="https://evolue.drtis.com.br"',
      'smtp.clientname="Evolue"',
    ],
  },
  'telemed-tempomedicinadefamilia': {
    firebaseConfig: {
      apiKey: 'AIzaSyAtVLQBG2hyVrTi9aK5VcNfO5a1p6D6ce4',
      authDomain: 'telemed-tempomedicinadefamilia.firebaseapp.com',
      projectId: 'telemed-tempomedicinadefamilia',
      storageBucket: 'telemed-tempomedicinadefamilia.appspot.com',
      messagingSenderId: '839439412210',
      appId: '1:839439412210:web:0e893ba79431cde7b3196b',
      measurementId: 'G-03ZV6J89HG',
    },
    functionsConfig: [
      'app.public_url="https://tempomedicinadefamilia.drtis.com.br"',
      'smtp.clientname="Tempo Medicina de Família Ltda"',
    ],
  },
  'telemed-hospitalfly': {
    firebaseConfig: {
      apiKey: 'AIzaSyC8BpHwi5EOQLuBuTvQ2V8OA4WMwMdNmoI',
      authDomain: 'telemed-hospitalfly.firebaseapp.com',
      projectId: 'telemed-hospitalfly',
      storageBucket: 'telemed-hospitalfly.appspot.com',
      messagingSenderId: '564994088144',
      appId: '1:564994088144:web:76a0a860769908780692d5',
      measurementId: 'G-Z0ZWXKNVRH',
    },
    functionsConfig: [
      'app.public_url=\"https://hospitalfly.drtis.com.br\"',
      'smtp.clientname=\"Hospital Fly Ltda\"',
    ],
  },
  'telemed-thequantic': {
    firebaseConfig: {
      apiKey: 'AIzaSyCq2Xh_IsrY4wBq2fyt50oWQ4kw-3vPiqo',
      authDomain: 'telemed-thequantic.firebaseapp.com',
      projectId: 'telemed-thequantic',
      storageBucket: 'telemed-thequantic.appspot.com',
      messagingSenderId: '765736855083',
      appId: '1:765736855083:web:e572f3d1ea751cf5c46c6e',
      measurementId: 'G-XCX051YH2H',
    },
    functionsConfig: [
      'app.public_url=\"https://thequantic.drtis.com.br\"',
      'smtp.clientname=\"The Quantic\"',
    ],
  },
  'telemed-om30': {
    firebaseConfig: {
      apiKey: 'AIzaSyBtEKLrnuDL9pAXvcRax7fznvwm2c0Y4sg',
      authDomain: 'telemed-om30.firebaseapp.com',
      projectId: 'telemed-om30',
      storageBucket: 'telemed-om30.appspot.com',
      messagingSenderId: '1011368582714',
      appId: '1:1011368582714:web:075055f738ea32de9b9f03',
      measurementId: 'G-Z0XCTMJ3JY',
    },
    functionsConfig: [
      'app.public_url=\"https://om30.drtis.com.br\"',
      'smtp.clientname=\"OM30\"',
    ],
  },
  'telemed-plasticalanconi': {
    firebaseConfig: {
      apiKey: 'AIzaSyDPjzLhvhZLWMp5CIszsdlExnE95ZW1ZLg',
      authDomain: 'telemed-plasticalanconi.firebaseapp.com',
      projectId: 'telemed-plasticalanconi',
      storageBucket: 'telemed-plasticalanconi.appspot.com',
      messagingSenderId: '227382549285',
      appId: '1:227382549285:web:dd39300e013aa54be818cc',
      measurementId: 'G-9WF9GQ02JW',
    },
    functionsConfig: [
      'app.public_url="https://cirurgiaplasticalanconi.drtis.com.br"',
      'smtp.clientname="Dr. Andre Laconi Cirurgião Plástico Eireli"',
    ],
  },
  'telemed-hapvida-8788b': {
    firebaseConfig: {
      apiKey: 'AIzaSyDWyrJWuKIr2RcqDob3C6waA177lG5EGSg',
      authDomain: 'telemed-hapvida-8788b.firebaseapp.com',
      projectId: 'telemed-hapvida-8788b',
      storageBucket: 'telemed-hapvida-8788b.appspot.com',
      messagingSenderId: '8457031912',
      appId: '1:8457031912:web:067d80e0f310583f28795d',
      measurementId: 'G-8LFRDWJ2BS',
    },
    functionsConfig: [
      'app.public_url="https:///hapvida.drtis.com.br"',
      'smtp.clientname="Hapvida Assistência Médica Ltda"',
    ],
  },
  'interconsulta-8202b': {
    firebaseConfig: {
      apiKey: 'AIzaSyDWyrJWuKIr2RcqDob3C6waA177lG5EGSg',
      authDomain: 'interconsulta-8202b.firebaseapp.com',
      projectId: 'interconsulta-8202b',
      storageBucket: 'interconsulta-8202b.appspot.com',
      messagingSenderId: '8457031912',
      appId: '1:8457031912:web:067d80e0f310583f28795d',
      measurementId: 'G-8LFRDWJ2BS',
    },
    functionsConfig: [
      'app.public_url=\"https:///interconsulta.drtis.com.br\"',
      'smtp.clientname=\"Interconsulta\"',
    ],
  },
  'telemed-hcor-homolog': {
    firebaseConfig: {
      apiKey: 'AIzaSyBdMqDOV9b69wl7kPefZiQapPRCbIqSOWk',
      authDomain: 'telemed-hcor-homolog.firebaseapp.com',
      projectId: 'telemed-hcor-homolog',
      storageBucket: 'telemed-hcor-homolog.appspot.com',
      messagingSenderId: '1005736655723',
      appId: '1:1005736655723:web:b8fcf606e784522da82a2e',
      measurementId: 'G-FGQXNDN0DF',
    },
    functionsConfig: [
      'app.public_url="https://hcorhomologacao.drtis.com.br"',
      'smtp.clientname="Homologação Hcor"',
    ],
  },
  'telemed-deltamedicina': {
    firebaseConfig: {
      apiKey: 'AIzaSyB53frC9HTodYzD62bP3fqlUiuBJwsAj24',
      authDomain: 'telemed-deltamedicina.firebaseapp.com',
      projectId: 'telemed-deltamedicina',
      storageBucket: 'telemed-deltamedicina.appspot.com',
      messagingSenderId: '388877372893',
      appId: '1:388877372893:web:be391fbda7478900173a34',
      measurementId: 'G-ELJCZG4SXH',
    },
    functionsConfig: [
      'app.public_url="https://deltamedicina.drtis.com.br"',
      'smtp.clientname="Delta Medicina Especializada Ltda"',
    ],
  },
  'telemed-clinicateste': {
    firebaseConfig: {
      apiKey: 'AIzaSyBlLCRQEsa83StdsjAZ-BlqWsBIJmoc2Yg',
      authDomain: 'telemed-clinicateste.firebaseapp.com',
      projectId: 'telemed-clinicateste',
      storageBucket: 'telemed-clinicateste.appspot.com',
      messagingSenderId: '933724509858',
      appId: '1:933724509858:web:69c71b382d9c75bcf329fb',
      measurementId: 'G-WD0T9P1MLG',
    },
    functionsConfig: [
      'app.public_url="https://clinicateste.drtis.com.br"',
      'smtp.clientname="Clínica Teste - Medicina Direta"',
    ],
  },
  'telemed-anestesia': {
    firebaseConfig: {
      apiKey: 'AIzaSyDEslRfRSpMDbvGcUmTusOD8y-nAX87X_Y',
      authDomain: 'telemed-anestesia.firebaseapp.com',
      projectId: 'telemed-anestesia',
      storageBucket: 'telemed-anestesia.appspot.com',
      messagingSenderId: '607190210506',
      appId: '1:607190210506:web:99547b4e07e99486226133',
      measurementId: 'G-84DPY1Z4JH',
    },
    functionsConfig: [
      'app.public_url="https://teleanestesia.drtis.com.br"',
      'smtp.clientname="Anestesia"',
    ],
  },
  'telemed-angelinacaron': {
    firebaseConfig: {
      apiKey: 'AIzaSyCRcNn7ld6-BNznlKCKMZysOIO-Fx_T7E8',
      authDomain: 'telemed-angelinacaron.firebaseapp.com',
      projectId: 'telemed-angelinacaron',
      storageBucket: 'telemed-angelinacaron.appspot.com',
      messagingSenderId: '463793888922',
      appId: '1:463793888922:web:05b8bfe05776030f3c0923',
      measurementId: 'G-ERDZTZQ8Z5',
    },
    functionsConfig: [
      'app.public_url="https://angelinacaron.drtis.com.br"',
      'smtp.clientname="Hospital Angelina Caron"',
    ],
  },
  'telemed-poclcc': {
    firebaseConfig: {
      apiKey: 'AIzaSyDJusGC20yxE0MbDfJAeIWY9W2s8xN9gj0',
      authDomain: 'telemed-poclcc.firebaseapp.com',
      projectId: 'telemed-poclcc',
      storageBucket: 'telemed-poclcc.appspot.com',
      messagingSenderId: '844349241234',
      appId: '1:844349241234:web:e4756041cdbf17a04bb34b',
      measurementId: 'G-Q2RR4X3467',
    },
    functionsConfig: [
      'app.public_url="https://poclcc.drtis.com.br"',
      'smtp.clientname="Liga Contra o Cancer"',
    ],
  },
  'telemed-glowebrazil': {
    firebaseConfig: {
      apiKey: 'AIzaSyB5XBQSpOtbNrvl3YujGN8tYb8Bw75ISUg',
      authDomain: 'telemed-glowebrazil.firebaseapp.com',
      projectId: 'telemed-glowebrazil',
      storageBucket: 'telemed-glowebrazil.appspot.com',
      messagingSenderId: '686233660602',
      appId: '1:686233660602:web:d1575f5dc93b842bece683',
      measurementId: 'G-2233BD76K0',
    },
    functionsConfig: [
      'app.public_url="http://glowebrazil.drtis.com.br"',
      'smtp.clientname="Global Wellness Brasil LTDA"',
    ],
  },
  'telemed-pocisadoramiranda': {
    firebaseConfig: {
      apiKey: 'AIzaSyBomYUoTPXzjG17VwdiYxMfsCLD8-Z6EOg',
      authDomain: 'telemed-pocisadoramiranda.firebaseapp.com',
      projectId: 'telemed-pocisadoramiranda',
      storageBucket: 'telemed-pocisadoramiranda.appspot.com',
      messagingSenderId: '837547810681',
      appId: '1:837547810681:web:64d869a15be4ce59e059a8',
      measurementId: 'G-YS8BCP3QC9',
    },
    functionsConfig: [
      'app.public_url="https://vamservicosvet.drtis.com.br"',
      'smtp.clientname="POC Dra Isadora Miranda"',
    ],
  },
  'telemed-acertafabioabud': {
    firebaseConfig: {
      apiKey: 'AIzaSyDR0LjKyTNhXkwjRtJNDi8u_afnEK-spCw',
      authDomain: 'telemed-acertafabioabud.firebaseapp.com',
      projectId: 'telemed-acertafabioabud',
      storageBucket: 'telemed-acertafabioabud.appspot.com',
      messagingSenderId: '409909469987',
      appId: '1:409909469987:web:08f4f7577fd65be15ce296',
      measurementId: 'G-4KYGYRV01E',
    },
    functionsConfig: [
      'app.public_url="https://acertaservicosmedicos.drtis.com.br"',
      'smtp.clientname="Dr Fabio Abud - Acerta Servicos Medicos - Medz Saúde"',
    ],
  },
  'telemed-sabara': {
    firebaseConfig: {
      apiKey: 'AIzaSyAPZ5rDdpkzp8P9yc9Ucn8HmZMjJLAucd8',
      authDomain: 'telemed-sabara.firebaseapp.com',
      projectId: 'telemed-sabara',
      storageBucket: 'telemed-sabara.appspot.com',
      messagingSenderId: '689911013484',
      appId: '1:689911013484:web:fa6baaf48e243ee3ecb849',
      measurementId: 'G-MT8VBTP7C1',
    },
    functionsConfig: [
      'app.public_url="https://sabaraemcasa.drtis.com.br"',
      'smtp.clientname="Hospital Sabará"',
    ],
  },
  'telemed-clinicafares': {
    firebaseConfig: {
      apiKey: 'AIzaSyDod33b9hld3uMK6hsOuI2yPEooNktjtm0',
      authDomain: 'telemed-clinicafares.firebaseapp.com',
      databaseURL: 'https://telemed-clinicafares-default-rtdb.firebaseio.com',
      projectId: 'telemed-clinicafares',
      storageBucket: 'telemed-clinicafares.appspot.com',
      messagingSenderId: '342706666889',
      appId: '1:342706666889:web:9968e156fd2bc4c28fb558',
      measurementId: 'G-7CPJ7FJDMQ',
    },
    functionsConfig: [
      'app.public_url="https://clinicafares.drtis.com.br"',
      'smtp.clientname="Clinica Fares"',
    ],
  },
  'telemed-onconnection': {
    firebaseConfig: {
      apiKey: 'AIzaSyBnhVfnHNMSRJL3e6i51qlZxuU-PBnyt5o',
      authDomain: 'telemed-onconnection.firebaseapp.com',
      databaseURL: 'https://telemed-onconnection-default-rtdb.firebaseio.com',
      projectId: 'telemed-onconnection',
      storageBucket: 'telemed-onconnection.appspot.com',
      messagingSenderId: '1055449600655',
      appId: '1:1055449600655:web:7a9c6ef5e28cb1a9bed6fa',
      measurementId: 'G-Z4QJRWGWCG',
    },
    functionsConfig: [
      'app.public_url="https://onconnection.drtis.com.br"',
      'smtp.clientname="Onconnection"',
    ],
  },
  'interconsulta-onconnecti-2c7ba': {
    firebaseConfig: {
      apiKey: 'AIzaSyB9GYcn7iDLF5jHmWjn-DvvnMNF1rS9KW4',
      authDomain: 'interconsulta-onconnecti-2c7ba.firebaseapp.com',
      databaseURL: 'https://interconsulta-onconnecti-2c7ba-default-rtdb.firebaseio.com',
      projectId: 'interconsulta-onconnecti-2c7ba',
      storageBucket: 'interconsulta-onconnecti-2c7ba.appspot.com',
      messagingSenderId: '156090685067',
      appId: '1:156090685067:web:3ff5cd631741981fc0a68e',
      measurementId: 'G-QM5QXJF99F',
    },
    functionsConfig: [
      'app.public_url="https://interonconnection.drtis.com.br/"',
      'smtp.clientname="Onconnection"',
    ],
  },
  'telemed-ibiapaba': {
    firebaseConfig: {
      apiKey: 'AIzaSyB71sKl2xWWBWxCiCkTPesyrqY-q-DpWyk',
      authDomain: 'telemed-ibiapaba.firebaseapp.com',
      projectId: 'telemed-ibiapaba',
      storageBucket: 'telemed-ibiapaba.appspot.com',
      messagingSenderId: '821394030880',
      appId: '1:821394030880:web:98ccde640c903002681745',
      measurementId: 'G-M5X0ZKR988',
    },
    functionsConfig: [
      'app.public_url="https://hibiapaba.drtis.com.br/"',
      'smtp.clientname="Hospital Ibiapaba"',
    ],
  },
  'telemed-virtummed': {
    firebaseConfig: {
      apiKey: 'AIzaSyDuR8jwYtHca5omVfW_E27F78Lig9UGDiU',
      authDomain: 'telemed-virtummed.firebaseapp.com',
      projectId: 'telemed-virtummed',
      storageBucket: 'telemed-virtummed.appspot.com',
      messagingSenderId: '630067134107',
      appId: '1:630067134107:web:c736a1044e1de54d7ad03e',
      measurementId: 'G-CMYDVK1DQJ',
    },
    functionsConfig: [
      'app.public_url="https://virtummed.drtis.com.br/"',
      'smtp.clientname="Clinica Virtum Med"',
    ],
  },
  'telemed-abpfoncologi': {
    firebaseConfig: {
      apiKey: 'AIzaSyB-T2m_TqNEJse0jvhgez3P2CvLlDlGL3c',
      authDomain: 'telemed-abpfoncologi.firebaseapp.com',
      databaseURL: 'https://telemed-abpfoncologi-default-rtdb.firebaseio.com',
      projectId: 'telemed-abpfoncologi',
      storageBucket: 'telemed-abpfoncologi.appspot.com',
      messagingSenderId: '386758439977',
      appId: '1:386758439977:web:8820187e77a376d8d55838',
      measurementId: 'G-1WN4RQYCRK',
    },
    functionsConfig: [
      'app.public_url=\"https://abpfoncologia.drtis.com.br/\"',
      'smtp.clientname=\"ABPF Oncologia SA\"',
    ],
  },
  'telemed-evora': {
    firebaseConfig: {
      apiKey: 'AIzaSyCn_QrfSHwnsx1NpupOhmo7Lqz82mZI2yI',
      authDomain: 'telemed-evora.firebaseapp.com',
      databaseURL: 'https://telemed-evora-default-rtdb.firebaseio.com',
      projectId: 'telemed-evora',
      storageBucket: 'telemed-evora.firebasestorage.app',
      messagingSenderId: '239867664060',
      appId: '1:239867664060:web:0f0782328609e8d32862b9',
      measurementId: 'G-HNJ1T2N4GM',
    },
    functionsConfig: [
      'app.public_url=\"https://evora.drtis.com.br/\"',
      'smtp.clientname=\"Evora Home Care\"',
    ],
  },
  'interconsulta-h2solucoessaude': {
    firebaseConfig: {
      apiKey: 'AIzaSyA4DwlqCFaIKsB5C4BfcGi_fFmPE4fyGmM',
      authDomain: 'interconsulta-h2solucoessaude.firebaseapp.com',
      databaseURL: 'https://interconsulta-h2solucoessaude-default-rtdb.firebaseio.com',
      projectId: 'interconsulta-h2solucoessaude',
      storageBucket: 'interconsulta-h2solucoessaude.appspot.com',
      messagingSenderId: '156330705436',
      appId: '1:156330705436:web:c42682086adff909cd95d9',
      measurementId: 'G-CLMB1SX2NJ',
    },
    functionsConfig: [
      'app.public_url=\"https://h2solucoesemsaude.drtis.com.br/\"',
      'smtp.clientname=\"H2 Tecnologia e serviços médicos\"',
    ],
  },
  'telemed-focus': {
    firebaseConfig: {
      apiKey: 'AIzaSyBrvNX6Lb1ckxZzSBIywuy3Iswe1cLYCwk',
      authDomain: 'telemed-focus.firebaseapp.com',
      projectId: 'telemed-focus',
      storageBucket: 'telemed-focus.firebasestorage.app',
      messagingSenderId: '681598859689',
      appId: '1:681598859689:web:37b962d3ba2a594f59acb8',
      measurementId: 'G-2SYENH0Y3F',
    },
    functionsConfig: [
      'app.public_url=\"https://focus.drtis.com.br/\"',
      'smtp.clientname=\"Focus\"',
    ],
  },
  'telemed-clinicamedicaonline': {
    firebaseConfig: {
      apiKey: 'AIzaSyBezMJTw8AbW4wyH6YZeK3RUmAQ1IR6O58',
      authDomain: 'telemed-clinicamedicaonline.firebaseapp.com',
      projectId: 'telemed-clinicamedicaonline',
      storageBucket: 'telemed-clinicamedicaonline.firebasestorage.app',
      messagingSenderId: '648087828063',
      appId: '1:648087828063:web:3f14269c31f1635334cdea',
      measurementId: 'G-FTTEFXYQ8K',
    },
    functionsConfig: [
      'app.public_url=\"https://clinicamedicaonline.drtis.com.br/\"',
      'smtp.clientname=\"Clínica Médica Online\"',
    ],
  },
  'telemed-lifetelemedicina': {
    firebaseConfig: {
      apiKey: 'AIzaSyCXpEIqqyfbb17GNOf7_lYmkC9ypSTkJJk',
      authDomain: 'telemed-lifetelemedicina.firebaseapp.com',
      projectId: 'telemed-lifetelemedicina',
      storageBucket: 'telemed-lifetelemedicina.firebasestorage.app',
      messagingSenderId: '804269589817',
      appId: '1:804269589817:web:af34ad65377a71c60414e8',
      measurementId: 'G-TGMYBSGNCL',
    },
    functionsConfig: [
      'app.public_url=\"https://lifetelemedicina.drtis.com.br/\"',
      'smtp.clientname=\"Life Telemedicina\"',
    ],
  },
  'telemed-ppap': {
    firebaseConfig: {
      apiKey: 'AIzaSyB4YZ-v8Gj5kv9LXeFgL0Xsqi0p2p1WZNA',
      authDomain: 'telemed-paap.firebaseapp.com',
      projectId: 'telemed-paap',
      storageBucket: 'telemed-paap.firebasestorage.app',
      messagingSenderId: '627293592311',
      appId: '1:627293592311:web:e5dcdcf569fab88b82d1f2',
      measurementId: 'G-4JX5P8PV2C',
    },
    functionsConfig: [
      'app.public_url=\"https://paap.drtis.com.br/\"',
      'smtp.clientname=\"PAAP - PRONTO ATENDIMENTO DE ALTA PERFORMANCE LTDA\"',
    ],
  },
  'telemed-santacasadefranca': {
    firebaseConfig: {
      apiKey: 'AIzaSyCpNVY6CcNJpsrBkbMoLGFZgqKa-_Vq2fA',
      authDomain: 'telemed-santacasadefranca.firebaseapp.com',
      projectId: 'telemed-santacasadefranca',
      storageBucket: 'telemed-santacasadefranca.firebasestorage.app',
      messagingSenderId: '866997989159',
      appId: '1:866997989159:web:f8949e03ed33a7650e8302',
      measurementId: 'G-FY1HDS1KVR',
    },
    functionsConfig: [
      'app.public_url=\"https://santacasadefranca.drtis.com.br/\"',
      'smtp.clientname=\"Santa Casa de Misericórdia de Franca\"',
    ],
  },
  'telemed-halbertsabin': {
    firebaseConfig: {
      apiKey: 'AIzaSyBdOk3x78PcqQ_5NkrRvPuP1sZHoy7ui9U',
      authDomain: 'telemed-halbertsabin.firebaseapp.com',
      databaseURL: 'https://telemed-halbertsabin-default-rtdb.firebaseio.com',
      projectId: 'telemed-halbertsabin',
      storageBucket: 'telemed-halbertsabin.firebasestorage.app',
      messagingSenderId: '423805201185',
      appId: '1:423805201185:web:28852f4d665c02139c6c60',
      measurementId: 'G-YP25RT66Z7',
    },
    functionsConfig: [
      'app.public_url=\"https://halbertsabin.drtis.com.br/\"',
      'smtp.clientname=\"Hospital Albert Sabin\"',
    ],
  },
  'telemed-telenordeste': {
    firebaseConfig: {
      apiKey: 'AIzaSyCqIhcEmXOsjIBco1EA43H7XF_wgCZGkkk',
      authDomain: 'telemed-telenordeste.firebaseapp.com',
      projectId: 'telemed-telenordeste',
      storageBucket: 'telemed-telenordeste.firebasestorage.app',
      messagingSenderId: '926505271106',
      appId: '1:926505271106:web:269d2ac2bf38b334d8d2db',
      measurementId: 'G-6X2PD4TD9S',
    },
    functionsConfig: [
      'app.public_url=\"https://telenordeste.drtis.com.br/\"',
      'smtp.clientname=\"Tele Nordeste\"',
    ],
  },
  'telemed-paixao-servicos': {
    firebaseConfig: {
      apiKey: 'AIzaSyAHzS_LDbnnZmGzNAeZkOVukEihiFiYJM0',
      authDomain: 'telemed-paixao-servicos.firebaseapp.com',
      projectId: 'telemed-paixao-servicos',
      storageBucket: 'telemed-paixao-servicos.firebasestorage.app',
      messagingSenderId: '1012167533648',
      appId: '1:1012167533648:web:30f0f6efafe70b3dc19d55',
      measurementId: 'G-EXFHD4Y0VV',
    },
    functionsConfig: [
      'app.public_url=\"https://ecpaixaoservicosmedicos.drtis.com.br/\"',
      'smtp.clientname=\"E. C. Paixão Servicos Medicos LTDA\"',
    ],
  },
  'telemed-irssl': {
    firebaseConfig: {
      apiKey: 'AIzaSyAQtxnUroC72awqXvP90w4esI1_W_6WL8s',
      authDomain: 'telemed-ir.firebaseapp.com',
      projectId: 'telemed-ir',
      storageBucket: 'telemed-ir.firebasestorage.app',
      messagingSenderId: '342980129313',
      appId: '1:342980129313:web:2912dc1b16ecc84195e960',
      measurementId: 'G-KSCM38HD4Q',
    },
    functionsConfig: [
      'app.public_url=\"https://irssl.hmj.drtis.com.br/\"',
      'smtp.clientname=\"IRSSL - Instituto de Responsabilidade Social Sírio Libanês\"',
    ],
  },
  'telemed-ssacontagem': {
    firebaseConfig: {
      apiKey: 'AIzaSyDdfpC7v4R_oUhA3kG7S-ZIadeDfxMaSag',
      authDomain: 'telemed-ssacontagem.firebaseapp.com',
      projectId: 'telemed-ssacontagem',
      storageBucket: 'telemed-ssacontagem.firebasestorage.app',
      messagingSenderId: '951784842864',
      appId: '1:951784842864:web:fe9df718cfc70370fe76b5',
      measurementId: 'G-3BYLXLZ7YZ',
    },
    functionsConfig: [
      'app.public_url=\"https://ssacontagem.drtis.com.br/\"',
      'smtp.clientname=\"SSAContagem\"',
    ],
  },
  'telemed-pjmed': {
    firebaseConfig: {
      apiKey: 'AIzaSyCgJAU9ArJYoI8uqBwv0bMMp8mjAc9z6QU',
      authDomain: 'telemed-pjmed.firebaseapp.com',
      projectId: 'telemed-pjmed',
      storageBucket: 'telemed-pjmed.firebasestorage.app',
      messagingSenderId: '478889786768',
      appId: '1:478889786768:web:3123c8f756e73fc30cc715',
      measurementId: 'G-S7FTB8CKD1',
    },
    functionsConfig: [
      'app.public_url=\"https://pjmed.drtis.com.br/\"',
      'smtp.clientname=\"PJ MED Participações e Gestão de Saúde\"',
    ],
  },
  'telemed-meupetclub': {
    firebaseConfig: {
      apiKey: 'AIzaSyDa9h_aIzDqHusx6thyzzqgzk2SjbSsnFE',
      authDomain: 'telemed-meupetclub.firebaseapp.com',
      projectId: 'telemed-meupetclub',
      storageBucket: 'telemed-meupetclub.firebasestorage.app',
      messagingSenderId: '701378879672',
      appId: '1:701378879672:web:c0601bbf86953e55b5944d',
      measurementId: 'G-0Y3F3LN5F7',
    },
    functionsConfig: [
      'app.public_url=\"https://meupetclub.drtis.com.br/\"',
      'smtp.clientname=\"Meu Pet Club\"',
    ],
  },
  'telemed-montetabor': {
    firebaseConfig: {
      apiKey: 'AIzaSyB3qJLPQmrK6iwNB1GSRhHD9eKI08C2rcA',
      authDomain: 'telemed-montetabor.firebaseapp.com',
      projectId: 'telemed-montetabor',
      storageBucket: 'telemed-montetabor.firebasestorage.app',
      messagingSenderId: '699668096267',
      appId: '1:699668096267:web:27664812b3a61d02a6ae0e',
      measurementId: 'G-2Y3R9WVD2X',
    },
    functionsConfig: [
      'app.public_url=\"https://montetabor.drtis.com.br/\"',
      'smtp.clientname=\"Monte Tabor Centro Ítalo-Brasileiro de Promoção Sanitária\"',
    ],
  },
  'telemed-sesgo': {
    firebaseConfig: {
      apiKey: 'AIzaSyCw_JfRDwXC_qljBLf-Pth5-YOfB-uaCMk',
      authDomain: 'telemed-sesgo.firebaseapp.com',
      projectId: 'telemed-sesgo',
      storageBucket: 'telemed-sesgo.firebasestorage.app',
      messagingSenderId: '1047623400376',
      appId: '1:1047623400376:web:2d14f8778fcb048b6d6d4d',
      measurementId: 'G-HCT0LSE38F',
    },
    functionsConfig: [
      'app.public_url=\"https://pocsesgo.drtis.com.br/\"',
      'smtp.clientname=\"Poc SES-GO\"',
    ],
  },
  'telemed-spdm': {
    firebaseConfig: {
      apiKey: 'AIzaSyC9BsronsrbFcdmvXOVcBGaTKYWD4-adM0',
      authDomain: 'telemed-spdm.firebaseapp.com',
      projectId: 'telemed-spdm',
      storageBucket: 'telemed-spdm.firebasestorage.app',
      messagingSenderId: '956505798627',
      appId: '1:956505798627:web:214432b8b57bb75ac252d6',
      measurementId: 'G-Y6J62TB7M6',
    },
    functionsConfig: [
      'app.public_url=\"https://spdm.drtis.com.br/\"',
      'smtp.clientname=\"Associação Paulista Para o Desenvolvimento da Medicina / Programa de Atenção Integral à Saúde (SPDM/PAIS)\"',
    ],
  },
};


export default clients;
